import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Card, Col, Row, Tab, Table, Tabs } from "react-bootstrap";
import { FaAtom, FaBriefcase, FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import api from "../../apiClient";
import Pagination from "../../Pagination";
import './CandidateDashboard.css';
import DashboardLayout from "./DashboardLayout";
import ResumeSelectionPopup from "./ResumeSelectionPopup";

const CompamyPage = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const companyId = location.state?.companyId; // Access companyId from URL parameter
  const userName = location.state?.userName;
  const userId = location.state?.userId;
  const [company, setCompany] = useState();
  const [countOfApplications, setCountOfApplications] = useState();
  const [countOfHR, setCountOfHR] = useState();
  const [countOfJobs, setCountOfJobs] = useState();
  const [activeTab, setActiveTab] = useState('overview'); // State to control the active tab
  const [companyLogo, setCompanyLogo] = useState("");
  const [companyBanner, setCompanyBanner] = useState("");
  const [jobs, setJobs] = useState([]);
  const [sortedColumn, setSortedColumn] = useState(null); // Track the currently sorted column
  const [sortOrder, setSortOrder] = useState(' '); // Track the sort order (asc or desc)
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(6);
  const [totalPages, setTotalPages] = useState(0);
  const [hasUserApplied, setHasUserApplied] = useState({});
  const [applyjobs, setApplyJobs] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [showResumePopup, setShowResumePopup] = useState(false);
  const [hasDreamApplied, setHasDreamApplied] = useState(false);
  const [resumes, setResumes] = useState([]);
  const [countOfTotalJobs, setCountOfTotalJobs] = useState();
  const [countOfshortlistedApplications, setCountOfshortlistedApplications] = useState();
  const [companyInfo, setCompanyInfo] = useState({
    overView: '',
    websiteLink: '',
    industryService: '',
    companySize: '',
    headquaters: '',
    year: '',
    specialties: '',
  });
  const { companyName } = useParams();  // Get companyName from URL

  const [selectedJob, setSelectedJob] = useState(null);
  const navigate = useNavigate();
  //console.log(companyId)

  // Getting Company details
  const fetchCompany = async (companyName) => {
    try {
      const response = await api.getCompanyByCompanyName(companyName);  // Fetch company data using API
      const companyData = response.data;
      setCompanyInfo(response.data)
      setCompany(companyData);
      setCompanyLogo(companyData.companyLogo);
      setCompanyBanner(companyData.companyBanner);
      fetchCompanyLogo(companyName);
      fetchCompanyBanner(companyName);
      fetchSocialMediaLinks(companyName);
    } catch (error) {
      console.error('Error fetching company details:', error);
    }
  };

 // console.log(companyInfo)
  useEffect(() => {
    if (companyName) {
      fetchData()
      fetchCompany(companyName);
      fetchCompanyLogo(companyName);
      fetchCompanyBanner(companyName);
      fetchSocialMediaLinks(companyName)
      fetchCountOfShortlistedCandidatesByCompany(userId, companyName)
      checkHasUserDreamApplied();
    }
  }, [companyName, userId]);

  // Getting Company Logo
  const fetchCompanyLogo = async (companyName) => {
    try {
      const response = await axios.get(`${BASE_API_URL}/logo`, { params: { companyName }, responseType: 'arraybuffer' });
      const image = `data:image/jpeg;base64,${btoa(
        new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
      )}`;
      setCompanyLogo(image);
    } catch (error) {
      console.error('Error fetching company logo:', error);
    }
  };
  // Getting Company Banner
  const fetchCompanyBanner = async (companyName) => {
    try {
      const response = await axios.get(`${BASE_API_URL}/banner`, { params: { companyName }, responseType: 'arraybuffer' });
      const image = `data:image/jpeg;base64,${btoa(
        new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
      )}`;
      setCompanyBanner(image);
    } catch (error) {
      console.error('Error fetching company banner:', error);
    }
  };

  //fetching data for the company...
  const fetchData = async () => {
    try {
      const fetchCountOfApplicationByCompany = await api.getCountOfApplicationsByCompany(companyName);
      setCountOfApplications(fetchCountOfApplicationByCompany.data);

      const fetchCountOfHRByCompany = await api.getCountOfHRByCompany(companyName);
      setCountOfHR(fetchCountOfHRByCompany.data);

      const countOfJobsByCompany = await api.getCountOfActiveJobsByCompany(companyName);
      setCountOfJobs(countOfJobsByCompany.data);

      const fetchCountOfTotalJobsByCompany = await api.getCountOfTotalJobsByCompany(companyName);
      setCountOfTotalJobs(fetchCountOfTotalJobsByCompany.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  //fetching data for the company... 
  const fetchCountOfShortlistedCandidatesByCompany = async () => {
    try {
      const response = await axios.get(
        `${BASE_API_URL}/getCountOfTotalShortlistedApplicationCompany?userId=${userId}&companyName=${companyName}`
      );
      setCountOfshortlistedApplications(response.data);
    } catch (error) {
      console.error('Error fetching count of jobs:', error);
    }
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0); // Reset page when page size change
  };

  const handlePageClick = (data) => {
    setPage(data.selected);
  };
  const handleSort = (column) => {
    let order = 'asc';
    if (sortedColumn === column) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    setSortedColumn(column);
    setSortOrder(order);
  };
  const [selectedJobSummary, setSelectedJobSummary] = useState(null);
  const handleViewSummary = (job) => {
    setSelectedJob(job);
  };
  const handleBackToList = () => {
    setSelectedJob(null); // Reset selectedJob to show the job list again
  };
  const handleCloseModal = () => {
    setSelectedJobSummary(null);
  };

  useEffect(() => {
    fetchJobsByCompany();
  }, [companyName, page, pageSize, sortedColumn, sortOrder]);

  // fetching Jobs for Company ...
  async function fetchJobsByCompany() {
    try {
      const params = {
        companyName: companyName,
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder,
      };
      const response = await axios.get(`${BASE_API_URL}/getJobsPaginationByCompany`, { params });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  // function for Apply as Dream Company... 
  const applyDreamCompanyJob = async (resumeId, companyName) => {
    let loadingPopup;

    try {
      // Show loading message using SweetAlert
      loadingPopup = Swal.fire({
        title: 'Applying to the job...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      const appliedOn = new Date(); // Get current date and time
      const year = appliedOn.getFullYear(); // Get the full year (e.g., 2024)
      const month = String(appliedOn.getMonth() + 1).padStart(2, '0'); // Get month (January is 0, so we add 1)
      const day = String(appliedOn.getDate()).padStart(2, '0'); // Get day of the month
      const formattedDate = `${year}-${month}-${day}`;
     // console.log(formattedDate); // Output: 2024-07-09 (example for today's date)

      const response = await axios.put(`${BASE_API_URL}/applyDreamCompany?userId=${userId}&companyName=${companyName}&formattedDate=${formattedDate}&resumeId=${resumeId}`);
    //  console.log(response.data);
      if (response.data) {
        Swal.close();

        // Show success message
        await Swal.fire({
          icon: "success",
          title: "Apply Successful!",
          text: "You have successfully applied for this company."
        });
        // setShowMessage(true);
        checkHasUserDreamApplied();
      }
    } catch (error) {
      console.error('Error applying for job:', error);
      // Close loading popup on error
      if (loadingPopup) {
        Swal.close();
      }
      // Show error message
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong! Please try again later.',
      });
    } finally {
      // Ensure loading popup is closed if still open
      if (loadingPopup) {
        Swal.close();
      }
    }
  };

  //function for Apply to company Jobs...
  const applyJob = async (jobId, resumeId) => {
    let loadingPopup;

    try {
      // Show loading message using SweetAlert
      loadingPopup = Swal.fire({
        title: 'Applying to the job...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      const appliedOn = new Date(); // Get current date and time
      const year = appliedOn.getFullYear(); // Get the full year (e.g., 2024)
      const month = String(appliedOn.getMonth() + 1).padStart(2, '0'); // Get month (January is 0, so we add 1)
      const day = String(appliedOn.getDate()).padStart(2, '0'); // Get day of the month
      const formattedDate = `${year}-${month}-${day}`;
      const response = await axios.put(`${BASE_API_URL}/applyJob`, null, {
        params: { jobId, userId, formattedDate, resumeId },
      });
      if (response.data) {

        setApplyJobs((prevApplyJobs) => [...prevApplyJobs, { jobId, formattedDate }]);
        setHasUserApplied((prev) => ({ ...prev, [jobId]: true }));
        // Close the loading popup
        Swal.close();
        //Show Success 
        await Swal.fire({
          icon: "success",
          title: "Apply Successful!",
          text: "You have successfully applied for this job."
        });
      }
    } catch (error) {
      console.error('Error applying for job:', error);
      // Close loading popup on error
      if (loadingPopup) {
        Swal.close();
      }
      // Show error message
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong! Please try again later.',
      });
    } finally {
      // Ensure loading popup is closed if still open
      if (loadingPopup) {
        Swal.close();
      }
    }
  };


  useEffect(() => {
    axios.get(`${BASE_API_URL}/getResume`, { params: { userId } })
      .then(response => {
        setResumes(response.data);
      })
      .catch(error => {
        console.error('Error fetching resumes:', error);
      });
  }, [userId]);


  // For checking user already applied to that Job or not..
  useEffect(() => {
    checkHasUserApplied();
  }, [jobs, userId]);
  const checkHasUserApplied = async () => {
    const applications = {};
    try {
      for (const job of jobs) {
        const response = await axios.get(`${BASE_API_URL}/applicationApplied`, {
          params: { jobId: job.jobId, userId }
        });
        applications[job.jobId] = response.data;
      }
      setHasUserApplied(applications);
    } catch (error) {
      console.error('Error checking application:', error);
    }
  };

  // For checking user already applied to that Company or not..
  const checkHasUserDreamApplied = async () => {
    try {
      const response = await axios.get(`${BASE_API_URL}/applicationDreamAplied`, {
        params: { userId, companyName: companyName }
      });
      //console.log("Has deam applied --> " + response.data)
      setHasDreamApplied(response.data);
    } catch (error) {
      console.error('Error checking application:', error);
    }
  };
  const handleApplyButtonClick = (jobId) => {
    setSelectedJobId(jobId);
    setShowResumePopup(true);
  };

  const [resumeId, setResumeId] = useState(0);
  const [selectedResume, setSelectedResume] = useState(null); // Store selected resume details

  //Select resume for Dream apply
  const handleResumeSelectOnCompany = async (resume) => {
    const resumeId = resume.target.value
    setSelectedResume(resumeId);
    if (resumeId) {
      setResumeId(resumeId);
      setShowResumePopup(false);  // Close the resume selection popup
    }
  };
  //Select resume for job apply
  const handleResumeSelect = async (resumeId) => {
    if (selectedJobId && resumeId) {
      await applyJob(selectedJobId, resumeId);
      setSelectedJobId(null);
      setShowResumePopup(false);
    }
  };

  // Apply to company as Dream application
  const handleApplyCompany = async () => {
    if (!resumeId || !userId) {
      toast.error('Please select a resume.');
      return;
    }
    await applyDreamCompanyJob(resumeId, companyName);

  };

  // for Social media links 
  const [socialMediaLinks, setSocialMediaLinks] = useState({
    facebookLink: '',
    twitterLink: '',
    instagramLink: '',
    linkedinLink: ''
  });

  const fetchSocialMediaLinks = async (companyName) => {
    try {
      const response = await api.getSocialMediaLinks(companyName);
      const { facebookLink, twitterLink, instagramLink, linkedinLink } = response.data;
      setSocialMediaLinks({
        facebookLink,
        twitterLink,
        instagramLink,
        linkedinLink,
      });
    } catch (error) {
      console.error('Error fetching social media links:', error);
    }
  };

  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;

  // For nav bar headers icons
  const customTabHeader = (title, icon) => (
    <div className="d-flex align-items-center">
      <span className="me-2">
        {/* <i className={icon} /> */}
        {icon}
      </span>
      <span class="fs-6 fw-bold">{title}</span>
    </div>
  );

  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // .. for getting company policy
  useEffect(() => {
    if (companyName) {
      const fetchDocuments = async () => {
        setLoading(true);
        try {
          const response = await api.getPolicyDocuments(companyName)
          if (response.data) {
            setDocuments(response.data); // Set documents data to state
          }
        } catch (err) {
          setError('Failed to fetch documents.');
          console.error(err);
        } finally {
          setLoading(false);
        }
      };

      fetchDocuments();
    }
  }, [companyName]);

  const [reapplyMonths, setReapplyMonths] = useState(12); // Default to 12 months

  // For getting company hiring pilicy
  useEffect(() => {
    if (companyName) {
      // Fetch policy data when the component is mounted
      api.getHiringPolicy(companyName).then((response) => {
        if (response.data) {
          const months = response.data.allowReapply ? response.data.reapplyMonths : 12;
          setReapplyMonths(months || 12); // Fallback to default if no value is provided
        }
      })
        .catch((error) => {
          console.error('Error fetching policy data:', error);
        });
    }
  }, [companyName]);
  return (
    <DashboardLayout>
      <div className="main-content" >
        {/* <Col xs={6} style={{ marginTop: '20px', marginLeft: '20px' }}>
          <Button onClick={() => navigate(-1)} variant="secondary">
            <FontAwesomeIcon icon={faArrowLeft} />
          </Button>)   
        </Col> */}
        <Row style={{ marginBottom: '20px' }}>
          <Card style={{ width: '100%', height: '60%' }}>
            <Card.Body style={{ padding: 0, position: 'relative' }}>
              <div style={{ position: 'relative', height: 'auto', maxHeight: '55%' }}>
                <img
                  src={companyBanner || "https://cdn.pixabay.com/photo/2016/04/20/07/16/logo-1340516_1280.png"}
                  alt="Company Banner"
                  className="banner-image"
                  style={{
                    width: '100%',
                    height: 'auto',
                    maxHeight: '200px',
                    objectFit: 'cover',
                    cursor: 'pointer',
                  }}
                />
              </div>

              <div style={{ position: 'absolute', top: '95%', left: '50px', transform: 'translateY(-50%)' }}>
                <img
                  src={companyLogo || "https://static.vecteezy.com/system/resources/previews/013/899/376/original/cityscape-design-corporation-of-buildings-logo-for-real-estate-business-company-vector.jpg"}
                  alt="Company Logo"
                  className="logo-image"
                  style={{
                    width: '20vw',
                    height: '20vw',
                    maxWidth: '150px',
                    maxHeight: '150px',
                    cursor: 'pointer',
                    objectFit: 'cover',
                    clipPath: 'none',
                    border: '5px solid #f0f0f0', // Adds a black border around the image
                    borderRadius: '10px', // Optional: adds rounded corners to the border
                  }}
                />
              </div>
            </Card.Body>
          </Card>

          {/* </Row>

              <Row style={{ marginTop: '5%', alignItems: 'center', marginLeft: '1%' }}> */}
          {/* <Col md={3} style={{ display: 'flex', alignItems: 'end', justifyContent: 'center'}}> */}
          <h2 className="responsive-title">
            <b>{companyName.toUpperCase()}</b>
          </h2>

          {/* </Col> */}
          {/* <Col md={9} style={{ display: 'flex', alignItems: 'end' }}> */}
          <span className="responsive-socials">
            {socialMediaLinks.facebookLink && (
              <a href={socialMediaLinks.facebookLink} target="_blank" rel="noopener noreferrer">
                <FaFacebook size={28} style={{ margin: '0 5px', color: '#3b5998' }} />
              </a>
            )}
            {socialMediaLinks.twitterLink && (
              <a href={socialMediaLinks.twitterLink} target="_blank" rel="noopener noreferrer">
                <FaTwitter size={28} style={{ margin: '0 5px', color: '#1da1f2' }} />
              </a>
            )}
            {socialMediaLinks.instagramLink && (
              <a href={socialMediaLinks.instagramLink} target="_blank" rel="noopener noreferrer">
                <FaInstagram size={28} style={{ margin: '0 5px', color: '#e4405f' }} />
              </a>
            )}
            {socialMediaLinks.linkedinLink && (
              <a href={socialMediaLinks.linkedinLink} target="_blank" rel="noopener noreferrer">
                <FaLinkedin size={28} style={{ margin: '0 5px', color: '#0077b5' }} />
              </a>
            )}
          </span>
          {/* </Col> */}
        </Row>
        <hr style={{ border: '1px solid black', marginTop: '0rem' }} />
        <Row className="hr-company_page-row2">
          <Col>
            <Tabs
              defaultActiveKey="overview"
              id="uncontrolled-tab-example"
              onSelect={(key) => setActiveTab(key)} // This is the correct way to handle tab change
            >
              <Tab eventKey="overview" title={customTabHeader("About  ", <FaAtom />)}>

              </Tab>
              <Tab eventKey="jobs" title={customTabHeader("Job  ", <FaBriefcase />)}>
              </Tab>
            </Tabs>
          </Col>
        </Row>


        <Row >
          <Col xs={12} md={8}>
            {activeTab === 'overview' && (
              <>
                <div className='company-overview'>
                  <Card className="job-details-text" style={{ width: '100%', height: "fit-content" }}>
                    <Card.Body>
                      <>
                        <h3>About {companyInfo.companyName}</h3>
                        {companyInfo.overView && <p className="company-Overview">{companyInfo.overView}</p>}

                        {companyInfo.websiteLink && (
                          <>
                            <h4>Website</h4>
                            <p className="company-website">
                              <a href={companyInfo.websiteLink} target="_blank" rel="noopener noreferrer">
                                {companyInfo.websiteLink}
                              </a>
                            </p>
                          </>
                        )}
                        {companyInfo.companyType && (
                          <>
                            <h4 className="company-subheader">Company Type</h4>
                            <p className="company-industry">{companyInfo.companyType}</p>
                          </>
                        )}
                        {companyInfo.industryService && (
                          <>
                            <h4>Industry</h4>
                            <p className="company-industry">{companyInfo.industryService}</p>
                          </>
                        )}

                        {companyInfo.companySize && companyInfo.companySize !== '0' && (
                          <>
                            <h4>Company Size</h4>
                            <p className="company-industry">{companyInfo.companySize}</p>
                          </>
                        )}

                        {companyInfo.headquaters && (
                          <>
                            <h4>Headquarters</h4>
                            <p className="company-headquarters">{companyInfo.headquaters}</p>
                          </>
                        )}

                        {companyInfo.year && companyInfo.year !== '0' && (
                          <>
                            <h4>Founded</h4>
                            <p className="company-founded">{companyInfo.year || ''}</p>
                          </>
                        )}

                        {companyInfo.specialties && (
                          <>
                            <h4>Specialties</h4>
                            <p className="company-specialties">{companyInfo.specialties}</p>
                          </>
                        )}
                      </>
                    </Card.Body>
                  </Card>
                </div>
              </>
            )}
            {activeTab === 'jobs' && (
              <>
                <div className="company-job" style={{ marginTop: '20px', width: '100%', height: "fit-content" }}>
                  {!selectedJob ? (
                    <div className="jobs_list">
                      {jobs.length > 0 && (
                        <div>
                          <Card body>
                            {/* <Card.Title>Light hoverable Table</Card.Title>
                            <p>
                              Add <code>.table-hover</code> to enable a hover state on table rows within a{" "}
                              <code>&lt;tbody&gt;</code>.
                            </p> */}
                            <div className="table-details-list table-wrapper">
                              <Table hover responsive  style={{ marginLeft: '5px', marginRight: '12px' }}>
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      onClick={() => handleSort('jobTitle')}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Job Title
                                      <span>
                                        <span
                                          style={{
                                            color: sortedColumn === 'jobTitle' && sortOrder === 'asc' ? 'black' : 'gray',
                                          }}
                                        >
                                          ↑
                                        </span>
                                        <span
                                          style={{
                                            color: sortedColumn === 'jobTitle' && sortOrder === 'desc' ? 'black' : 'gray',
                                          }}
                                        >
                                          ↓
                                        </span>
                                      </span>
                                    </th>
                                    <th
                                      scope="col"
                                      onClick={() => handleSort('applicationDeadline')}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Application Deadline{' '}
                                      <span>
                                        <span
                                          style={{
                                            color: sortedColumn === 'applicationDeadline' && sortOrder === 'asc' ? 'black' : 'gray',
                                          }}
                                        >
                                          ↑
                                        </span>{' '}
                                        <span
                                          style={{
                                            color: sortedColumn === 'applicationDeadline' && sortOrder === 'desc' ? 'black' : 'gray',
                                          }}
                                        >
                                          ↓
                                        </span>
                                      </span>
                                    </th>
                                    <th
                                      scope="col"
                                      onClick={() => handleSort('skills')}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Skills{' '}
                                      <span>
                                        <span
                                          style={{
                                            color: sortedColumn === 'skills' && sortOrder === 'asc' ? 'black' : 'gray',
                                          }}
                                        >
                                          ↑
                                        </span>{' '}
                                        <span
                                          style={{
                                            color: sortedColumn === 'skills' && sortOrder === 'desc' ? 'black' : 'gray',
                                          }}
                                        >
                                          ↓
                                        </span>
                                      </span>
                                    </th>
                                    <th scope='col'>Job Summary</th>
                                    <th scope='col'>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {jobs.map(job => (
                                    <tr key={job.id} id='job-table-list'>
                                      <td
                                        title={job.jobCategory === "evergreen" && !job.applicationDeadline ?
                                          "This position is always open for hiring, feel free to apply anytime!" :
                                          ""
                                        }
                                      >
                                        {job.jobTitle}
                                      </td>
                                      <td>
                                        {job.jobCategory === "evergreen" && !job.applicationDeadline ? (
                                          <span style={{ color: 'green', fontWeight: 'bold' }} title="This position is always open for hiring, feel free to apply anytime!">
                                            Evergreen Job - No Due Date
                                          </span>
                                        ) : (
                                          job.applicationDeadline || 'Not Specified'
                                        )}
                                      </td>

                                      <td>{job.skills}</td>
                                      <td>
                                        <Button variant="secondary" className='description btn-rounded' onClick={() => handleViewSummary(job)}>View</Button>
                                      </td>                                <td>
                                        {hasUserApplied[job.jobId] === true || (applyjobs && applyjobs.jobId === job.jobId) ? (
                                          <p>Applied</p>
                                        ) : (
                                          <Button onClick={() => handleApplyButtonClick(job.jobId)}>Apply</Button>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                            <Pagination
                              page={page}
                              pageSize={pageSize}
                              totalPages={totalPages}
                              handlePageSizeChange={handlePageSizeChange}
                              isPageSizeDisabled={isPageSizeDisabled}
                              handlePageClick={handlePageClick}
                            />
                          </Card>
                        </div>
                      )}
                      {jobs.length === 0 && <h1>No jobs found.</h1>}
                    </div>
                  ) : (
                    <div className="selected-job-details m-2">
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          variant="primary"
                          onClick={handleBackToList}
                        >
                          Back to Jobs
                        </Button>
                      </div>
                      <h3>Job Details</h3>
                      <p><strong>Title:</strong> {selectedJob.jobTitle}</p>
                      <p><strong>Type:</strong> {selectedJob.jobType}</p>
                      <p><strong>Skills:</strong> {selectedJob.skills}</p>
                      <p><strong>Posting Date:</strong> {selectedJob.postingDate}</p>
                      <p><strong>Vacancy:</strong> {selectedJob.numberOfPosition}</p>
                      <p><strong>Salary:</strong> {selectedJob.salary}</p>
                      <p><strong>Location:</strong> {selectedJob.location}</p>
                      <p><strong>Application Deadline:</strong>  {selectedJob.jobCategory === "evergreen" && !selectedJob.applicationDeadline ? (
                        <span style={{ color: 'green', fontWeight: 'bold' }} title="This position is always open for hiring, feel free to apply anytime!">
                          Evergreen Job - No Due Date
                        </span>
                      ) : (
                        selectedJob.applicationDeadline || 'Not Specified'
                      )}</p>
                      <strong>Job Summary:</strong>
                      <pre className="job-details-text">
                        {selectedJob.jobsummary}
                      </pre>
                    </div>
                  )}
                </div>
              </>
            )}
          </Col>
          <Col xs={12} md={4}>
            <Card className='key-stats' style={{ width: '360px', height: 'fit-content' }}>
              <Card.Body>
                <Row className="mb-3">
                  <Col>
                    {hasDreamApplied === true ? (
                      <p style={{
                        color: '#28a745', /* Green color for the text */
                        fontSize: '18px', /* Larger font size */
                        fontWeight: 'bold', /* Bold text */
                        backgroundColor: '#e9f5e9', /* Light green background color */
                        padding: '10px',
                        borderRadius: '5px', /* Rounded corners */
                        textAlign: 'left', /* Center-align the text */
                        margin: '10px 0', /* Margin above and below the paragraph */
                        boxShadow: 'rgba(0, 0, 0, 0.1)', /* Subtle shadow effect */
                        width: '100px'
                      }}>
                        Applied
                      </p>
                    ) : (
                      <>
                        <div className="resume-dropdown-container">


                          {/* Check if there are no resumes */}
                          {resumes.length === 0 ? (
                            <div>
                              <p className="text-danger">Please add your resume first.</p>
                              <Link to="/candidate-dashboard/resume/resumeAdd" state={{ userName: userName, userId: userId }}>
                                <Button variant='primary'>ADD RESUME</Button>
                              </Link>
                            </div>
                          ) : (
                            // If there are resumes, display the dropdown
                            <>
                              <h5 className="fw-bold">Select Resume</h5>

                              <select
                                id="resumeSelect"
                                value={selectedResume}
                                onChange={handleResumeSelectOnCompany}
                                required
                                className="form-select"
                              >
                                <option value="">Select Resume</option>
                                {resumes.map((resume) => (
                                  <option key={resume.id} value={resume.id}>
                                    {resume.message}
                                  </option>
                                ))}
                              </select></>
                          )}
                        </div>

                        {/* Apply button, will only be visible if a resume is selected */}
                        {resumes.length > 0 && (
                          <Button
                            variant="success"
                            onClick={handleApplyCompany}
                            disabled={!selectedResume} // This disables the button if no resume is selected
                          >
                            Apply
                          </Button>
                        )}
                      </>

                    )}
                  </Col>
                </Row>
                <h3><b>Other Information</b></h3>
                <Row className="mb-2">
                  <Col>
                    <h5>Applicants: {countOfApplications}</h5>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <h5>Total HR's: {countOfHR}</h5>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <h5>Total Jobs:{countOfTotalJobs}</h5>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <h5>Key Stats:</h5>
                    <ul>
                      <li>Active Job Postings:{countOfJobs}</li> {/* Placeholder values */}
                      <li>Shortlisted Applications:{countOfshortlistedApplications} </li>
                      <li>Avg. Time to Fill a Job: 7 days</li>
                    </ul>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Card className="key-stats" style={{ width: '360px', height: 'fit-content', marginBottom: '10px' }}>
              <Card.Body>

                <h3><b>Company Policies</b></h3>
                <h4>Job Reapply Policy</h4>
                <p>
                  Candidates can reapply after <strong>{reapplyMonths}</strong> months.
                </p>
                {documents.length === 0 ? (
                  <p>No documents available for this company.</p>
                ) : (
                  <div>
                    {documents.map((document) => (
                      <div key={document.documentId} style={{ marginBottom: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <strong>{document.documentTitle}:</strong>
                          <a
                            href={`data:application/octet-stream;base64,${document.documentFile}`}
                            download={document.documentTitle}
                            className="btn btn-primary"
                            style={{ marginLeft: '10px' }}>
                            Download
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
      <div>
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
      </div>
      {showResumePopup && (
        <ResumeSelectionPopup
          resumes={resumes}
          onSelectResume={handleResumeSelect}
          show={true}
          onClose={() => setShowResumePopup(false)}
          userName={userName}    // Pass userName
          userId={userId}        // Pass userId
        />
      )}
    </DashboardLayout>
  );
};
export default CompamyPage;


